/**
 * breakpoint
 * 
 * @author jjarolim
 */

const breakpoints = [
    { name: 'xs', min: 0, max: 575 },
    { name: 'sm', min: 576, max: 767 },
    { name: 'md', min: 768, max: 991 },
    { name: 'lg', min: 992, max: 1199 },
    { name: 'xl', min: 1200, max: 1613 },
    { name: 'xxl', min: 1614, max: 9999 }
]

const debounce = (func, timeout = 300) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

const getBreakpoint = () => {
    for ( let i=0; i<breakpoints.length; i++ ) {
        const breakpoint = breakpoints[ i ];
        if ( window.innerWidth > breakpoint.min && window.innerWidth < breakpoint.max ) {
            return breakpoint;
        }
    }
    return null;
}

const watchBreakpoint = callback => {

    let last_breakpoint = getBreakpoint();

    addEventListener( 
        'resize', 
        debounce( 
            event => {

                const current_breakpoint = getBreakpoint();

                if ( current_breakpoint.name !== last_breakpoint.name ) {
                    callback( { from: last_breakpoint, to: current_breakpoint } );
                    last_breakpoint = current_breakpoint;
                }

            },
            50 
        ) 
    );

}

export {
    getBreakpoint,
    watchBreakpoint
}